<template>
    <div class="ProfileView">
      <QuickMenuComponent />
      <v-container>
        <v-row>
          <v-col align-self="center" align="center">
            <QuickMenuProfileComponent />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="SectionTitle">
              Profile Information
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col align-self="center" align="center">
            <div class="Section">
              <div align="right" class="mb-10 Verify">
                Pending verification <v-icon color="orange" large class="mx-2">mdi-check-decagram</v-icon>
              </div>
              <v-text-field prepend-icon="ID" label="ID" readonly filled outlined v-model="id" append-icon="mdi-content-copy"></v-text-field>
              <v-text-field prepend-icon="mdi-card-account-details" label="Personal ID" filled outlined></v-text-field>
              <v-text-field prepend-icon="mdi-account" label="Name" filled outlined></v-text-field>
              <v-text-field prepend-icon="mdi-map-marker" label="Personal Address" filled outlined></v-text-field>
              <div class="d-flex">
                <v-autocomplete prepend-icon="mdi-home-city-outline" class="mx-2" label="Country" filled outlined></v-autocomplete>
                <v-autocomplete class="mx-2" label="State" filled outlined></v-autocomplete>
                <v-autocomplete class="mx-2" label="City" filled outlined></v-autocomplete>
                <v-text-field type="phone" class="mx-2" label="ZIP Code" filled outlined></v-text-field>
              </div>
              <v-text-field prepend-icon="mdi-phone" label="Contact Number" filled outlined></v-text-field>
              <v-autocomplete prepend-icon="mdi-translate" class="mx-2" label="Language" filled outlined></v-autocomplete>
              <div align="right" class="my-5">
                <v-btn class="px-10 mx-2" large color="primary" :disabled="true">Request Verification</v-btn>
                <v-btn class="px-10 mx-2" x-large color="success">Save</v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
import './_ProfileView.scss'
import QuickMenuComponent from '@/components/QuickMenuComponent/QuickMenuComponent'
import QuickMenuProfileComponent from '@/components/QuickMenuProfileComponent/QuickMenuProfileComponent'
export default {
  name: 'ProfileView',
  components: { QuickMenuProfileComponent, QuickMenuComponent },
  data () {
    return {
      id: 'ID>>324232523rc3534546362>12310238940fsdjoewrr3nfnkl35',
      timezones: []
    }
  }
}
</script>
